import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routesPC = [
  {
    path: '/',
    redirect: { name: 'lunaAi' }
  },
  {
    path: '/lunaAi',
    name: 'lunaAi',
    component: () => import('@/views/PC/lunaAi/index.vue')
  }
]

const routesMobile = [
  {
    path: '/',
    redirect: { name: 'lunaAi' }
  },
  {
    path: '/lunaAi',
    name: 'lunaAi',
    component: () => import('@/views/mobile/lunaAi/index.vue')
  }
]

const isMobile = window.matchMedia('(max-width: 767px)').matches
const routes = isMobile ? routesMobile : routesPC
const router = new VueRouter({ routes })
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router
